import type { ReactNode } from 'react';

interface MetricCardProps {
  label: string;
  value: ReactNode;
  trend?: { direction: 'up' | 'down' | 'flat'; text: string };
  sub?: string;
  valueClassName?: string;
}

export function MetricCard({ label, value, trend, sub, valueClassName = '' }: MetricCardProps) {
  const trendColor = trend?.direction === 'up'
    ? 'text-success'
    : trend?.direction === 'down'
      ? 'text-danger'
      : 'text-text-muted';

  const trendArrow = trend?.direction === 'up'
    ? '▲'
    : trend?.direction === 'down'
      ? '▼'
      : '—';

  return (
    <div className="bg-bg-card border border-border rounded-md px-5 py-4">
      <div className="text-[0.68rem] font-semibold text-text-muted uppercase tracking-wider mb-1.5">
        {label}
      </div>
      <div className="flex items-baseline gap-2">
        <div className={`font-display text-2xl font-bold tracking-tight ${valueClassName}`}>
          {value}
        </div>
        {trend && (
          <span className={`text-[0.68rem] font-semibold flex items-center gap-0.5 ${trendColor}`}>
            {trendArrow} {trend.text}
          </span>
        )}
      </div>
      {sub && (
        <div className="text-[0.72rem] text-text-muted mt-0.5">{sub}</div>
      )}
    </div>
  );
}
